import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const ServiceCard = ({ service, i = 0 }) => (
  <motion.div
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    className="h-full"
  >
    <Link
      to={`/expertise#${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group relative flex flex-col justify-between h-full min-h-[280px] p-7 sm:p-8 rounded-3xl glass hover:bg-white/70 hover:shadow-[0_20px_50px_rgba(31,35,40,0.12)] hover:-translate-y-1 transition-all duration-500 ease-expo text-coal"
    >
      <div className="flex items-start justify-between">
        <span className="label-tech text-cobalt">{service.number}</span>
        <span className="w-9 h-9 rounded-full bg-white/60 flex items-center justify-center group-hover:bg-coal group-hover:text-paper transition-colors duration-500">
          <ArrowUpRight size={16} className="transition-transform duration-500 ease-expo group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
      <div className="mt-14">
        <h3 className="t-h3 mb-3">{service.title}</h3>
        <p className="text-sm leading-relaxed max-w-xs text-graphite">{service.description}</p>
      </div>
    </Link>
  </motion.div>
);

export default ServiceCard;
